export function	formatStr (aModel, url) {
	let Property
	let result = url

	for (Property in aModel) {
		if (aModel.hasOwnProperty(Property)) {
			result = result.replace('{:' + Property + '}', aModel[Property])
		}
	}

	return result
}

export function defaultValue (aValue, aDefault) {
	if (typeof aValue === "undefined" || aValue === null) {
		return aDefault
	}

	return aValue
}

export const isData = (aValue) => {
	if (typeof aValue === "undefined") {
		return false
	}

	if (aValue === null) {
		return false
	}

	return true
}

export function newCalcGeoLocation (aLocation) {
	let isDMS = !(aLocation.match(/(([0-9]+[°][0-9]+['][0-9]+([\*.][0-9]+)?["][NS])|([-+NS][0-9]+[°][0-9]+['][0-9]+([\*.][0-9]+)?["]))[\s,]+(([0-9]+[°][0-9]+['][0-9]+([\*.][0-9]+)?["][EOW])|([-+EOW][0-9]+[°][0-9]+['][0-9]+([\*.][0-9]+)?["]))/i) === null)
	let isDMM = !(aLocation.match(/(([0-9]+[°][0-9]+([\*.][0-9]+)?['][NS])|([-+NS][0-9]+[°][0-9]+([\*.][0-9]+)?[']))[\s,]+(([0-9]+[°][0-9]+([\*.][0-9]+)?['][EOW])|([-+EOW][0-9]+[°][0-9]+([\*.][0-9]+)?[']))/i) === null)
	let isDDD = !(aLocation.match(/(([0-9]+([\*.][0-9]+)?[°]?[NS]?)|([-+NS][0-9]+([\*.][0-9]+)?[°]?))[\s,]+(([0-9]+([\*.][0-9]+)?[°]?[EOW]?)|([-+EOW][0-9]+([\*.][0-9]+)?[°]?))/i) === null)

	let Lat = 0
	let Lng = 0

	let parseDMS = (aValue) => {
		return 0
	}
}

export function calcGeoLocation (aLocation) {
	let splitter = (coordinates) => coordinates.split(/[\s,'"°]+/).map(part => String(part).trim())

	let lLocation = aLocation
	if (typeof aLocation !== "string") {
		lLocation = "0 0, 0 0"
	}

	let parts = lLocation.split(",")
	if (!Array.isArray(parts) || parts.length < 2) {
		return {
			lat: 0,
			lng: 0
		}
	}

	let lat = parts[0].trim().split(" ").map(value => parseFloat(value))
	let lng = parts[1].trim().split(" ").map(value => parseFloat(value))
	let latDD = lat[0] + lat[1] * 1/60
	let lngDD = lng[0] + lng[1] * 1/60

	return {
		lat: latDD,
		lng: lngDD
	}
}



// WEBPACK FOOTER //
// ./src/tools.js